//
//

import { mapActions, mapGetters, mapMutations } from "vuex";
import { required } from "vuelidate/lib/validators";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQBadge from "@/components/Generics/AQBadge/AQBadge.vue";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQRadio from "@/components/Generics/AQRadio/AQRadio.vue";
import AQDropdown from "@/components/Generics/AQDropdown/AQDropdown.vue";
import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";
import { getDynamicEnv } from "@/assets/js/appFunc";
import AQUploader from "@/components/Generics/AQUploader/AQUploader.vue";
import AQAvatarUploader from "@/components/Generics/AQAvatarUploader/AQAvatarUploader.vue";
import AQMenu from "@/components/Generics/AQMenu/AQMenu.vue";
import { currentApp } from "@/store/modules/apps/getters";
import { ENGINE_REST_PATH } from "@/assets/js/appConfig";
import download from "@/assets/images/Buttons/download-icon-button.svg";

export default {
    name: "NewApps",
    components: {
        AQInput,
        AQButton,
        AQModal,
        AQUploader,
        AQAvatarUploader,
        AQRadio,
        AQMenu,
        AQDropdown,
        AQDialog,
        AQBadge
    },

    data() {
        return {
            showUploader: true,
            appNameValidation: false,
            selectedAppTypeLabel: "",
            blockchainTypeLabel: this.$t("apps.initialBlockchainTypeLabel"),
            previewImage: null,
            nameApp: this.$t("apps.defaultNameApp"),
            appDescription: null,
            app: {
                status: "",
                createdBy: "",
                iterations: ""
            },
            readonly: false,
            selectedName: this.$t("apps.defaultNameApp"),
            inputActionsCode: "",
            fileUpdateImport: null,
            selectedDescription: "",
            exceedSize: false,
            appDescriptionValidation: false,
            someIndex: 0,
            retentionValue: "INDEFINITE",
            period: 1,
            retentionPeriod: "Y",
            periodValues: [
                {
                    label: this.$t("apps.days"),
                    value: "D"
                },
                {
                    label: this.$t("apps.weeks"),
                    value: "W"
                },
                {
                    label: this.$t("apps.months"),
                    value: "M"
                },
                {
                    label: this.$t("apps.years"),
                    value: "Y"
                }
            ],
            typeOptions: [
                {
                    label: "Standard",
                    value: "STANDARD"
                },
                {
                    label: "Blockchain",
                    value: "BLOCKCHAIN"
                }
            ],
            periodRetentionChange: 0,
            extensions: ".jpg,.png,.svg",
            appUpdate: false,
            downloadIcon: `img:${download}`,
            showWarningText: false,
            avatarToSave: null,
            imageToRemove: false,
            updateDisabledBtn: true
        };
    },
    validations: {
        nameApp: {
            required
        }
    },
    computed: {
        ...mapGetters("apps", [
            "currentApp",
            "apps",
            "getCurrentAppUserPermissions"
        ]),
        ...mapGetters("userProfile", ["userDataDetails"]),
        ...mapGetters("version", ["latestVersionId"]),
        ...mapGetters("admin", ["userList", "featuresByTenant"]),
        ...mapGetters("main", ["interfaceDirty"]),
        checkPeriod() {
            let stateToReturn = false;
            if (this.retentionValue === "LIMITED") {
                const regex = /^(0|[1-9][0-9]*)$/;
                stateToReturn = !regex.test(this.period);
            }
            return stateToReturn;
        },
        ddlSelectContract() {
            return {
                options: this.periodValues,
                fitParentContainer: true
            };
        },
        canExport() {
            return this.checkIfHasPermissions(this.getCurrentAppUserPermissions, "EX");
        },
        nameValidator() {
            let msg = "";
            if (this.appNameValidation && this.exceedSize) {
                msg = this.$t("apps.exceededLength");
            } else if (this.appNameValidation) {
                msg = this.$t("apps.noName");
            }
            return msg;
        },
        descriptionValidator() {
            let msg = "";
            if (this.appDescriptionValidation) {
                msg = this.$t("apps.exceededLength");
            }
            return msg;
        },
        showButtonUpload() {
            let display = false;
            const feature = this.featuresByTenant.find(element => element.code === "APP_UPDT");
            const hasPermissions = this.checkIfHasPermissions(this.getCurrentAppUserPermissions, "UA");

            if (feature && hasPermissions && this.currentApp.processInformation && this.currentApp.processInformation.updatable) {
                display = feature.enabled;
            }
            return display;
        },
        fileName() {
            if (this.fileUpdateImport && this.fileUpdateImport.name) {
                return this.fileUpdateImport.name;
            }
            return this.$t("apps.chooseFile");
        },
        maxSize() {
            return getDynamicEnv("UPLOAD_LIMIT_APP_AVATAR");
        }
    },

    watch: {
        currentApp: {
            handler(newValue) {
                if (newValue && newValue.id) {
                    if (newValue.appCreatorName) {
                        this.app.createdBy = newValue.appCreatorName;
                    } else {
                        this.app.createdBy = `${this.userDataDetails.firstName} ${this.userDataDetails.lastName}`;
                    }
                    if (newValue.type === "GFSC" || newValue.blockchainType === "BLOCKCHAIN") {
                        this.selectedAppTypeLabel = "BLOCKCHAIN";
                    } else if (newValue.type === "GF" || newValue.blockchainType === "STANDARD") {
                        this.selectedAppTypeLabel = "STANDARD";
                    }
                    if (newValue.retention && newValue.retention.type === "LIMITED") {
                        this.retentionValue = newValue.retention.type;
                        if (newValue.retention.period) {
                            const retPer = newValue.retention.period;
                            this.retentionPeriod = retPer.slice(-1);
                            const [, transformData] = retPer.split("P");
                            this.period = transformData.slice(0, transformData.length - 1);
                        }
                    }
                    this.nameApp = newValue.name;
                    this.inputActionsCode = newValue.code;
                    this.appDescription = newValue.description;
                    this.previewImage = newValue.imageId ? `${ENGINE_REST_PATH}/app/files/${newValue.imageId}/IMAGE` : null;
                    if (!newValue.publishStatus) {
                        this.app.status = this.$t("apps.NOT_PUBLISHED");
                    } else {
                        this.statusApp(newValue.publishStatus);
                    }
                }
            },
            immediate: true
        },

        nameApp: {
            handler() {
                if (this.nameApp && this.currentApp.name !== this.nameApp) {
                    this.checkPermissionsInterfaceDirty(true);
                } else {
                    this.checkPermissionsInterfaceDirty();
                }
            },
            deep: true
        },
        retentionValue: {
            handler() {
                if (!this.currentApp.retention
                || (this.retentionValue && this.currentApp.retention.type !== this.retentionValue)
                || (this.currentApp.retention.type === this.retentionValue && this.currentApp.retention.period !== `P${this.period}${this.retentionPeriod}`)) {
                    this.checkRetentionValues();
                    this.checkPermissionsInterfaceDirty(true);
                } else {
                    this.checkPermissionsInterfaceDirty();
                }
            }
        },
        appDescription: {
            handler() {
                if (this.currentApp.description !== this.appDescription) {
                    this.checkPermissionsInterfaceDirty(true);
                } else {
                    this.checkPermissionsInterfaceDirty();
                }
            },
            deep: true
        }
    },
    created() {
        this.$root.$emit("setReadonlyTag", (this.$route.params && this.$route.params.permissions && this.$route.params.permissions.readonly));
        this.$root.$emit("hideSaveBtn", true);
        this.readonly = this.$route.params.permissions && this.$route.params.permissions.readonly;
        this.$store.commit("main/setSaveBtnVisible", this.readonly);
        const vm = this;
        this.$root.$on("focusAppSetting", value => {
            const elmnt = document.getElementById(value);
            elmnt.scrollIntoView({ behavior: "smooth" });
        });
        this.$root.$on("oneAtATime-highlights", () => {
            if (
                (vm.readonly && vm.$oneAtATime.state.$currentRoomEmpty)
        || !vm.$oneAtATime.state.$currentRoomEmpty
            ) {
                this.loadDataWebsocket();
            }
            vm.readonly = !vm.$oneAtATime.state.$currentRoomEmpty;
        });
        this.$root.$on("highlightsSave", () => {
            this.$store.commit("main/setInterfaceDirty", false);
            if (this.currentApp && !this.currentApp.appVersion) {
                this.currentApp.appVersion = this.latestVersionId;
            }
            this.applicationSave();
        });
    },

    mounted() {
        window.addEventListener("dragover", this.prevDefault, false);
        window.addEventListener("drop", this.prevDefault, false);
        this.initializeComponent();
        this.$root.$emit("disableSaveButton", false);
        this.$root.$emit("setReadonlyTag", (this.$route.params && this.$route.params.permissions && this.$route.params.permissions.readonly));
        this.readonly = this.$route.params.permissions && this.$route.params.permissions.readonly;
        this.$store.commit("main/setSaveBtnVisible", this.readonly);
        this.$root.$emit("hideSaveBtn", true);
    },
    activated() {
        this.resetErrors();
        this.initializeComponent();
        this.readonly = this.$route.params.permissions && this.$route.params.permissions.readonly;
        this.$store.commit("main/setSaveBtnVisible", this.readonly);
        this.$root.$emit("disableSaveButton", false);
        this.$root.$emit("setReadonlyTag", (this.$route.params && this.$route.params.permissions && this.$route.params.permissions.readonly));
        this.$root.$emit("hideSaveBtn", true);
        this.$store.commit("rules/setShowRuleTesting", false);
    },
    deactivated() {
        this.$root.$emit("showCheckedSaveBtn", false);
        this.$root.$emit("setReadonlyTag", false);
        this.blockchainTypeLabel = null;
        this.$root.$emit("editView", false);
        this.nameApp = null;
        this.appDescription = null;
        this.retentionValue = this.currentApp.retention ? this.currentApp.retention.type : "INDEFINITE";
        if (this.currentApp.retention && this.currentApp.retention.type === "INDEFINITE") {
            this.period = "1";
            this.retentionPeriod = "Y";
        } else if (this.currentApp.retention) {
            const retPer = this.currentApp.retention.period;
            this.retentionPeriod = retPer.slice(-1);
            const [, transformData] = retPer.split("P");
            this.period = transformData.slice(0, transformData.length - 1);
        }
        this.periodRetentionChange++;
    },
    beforeDestroy() {
        window.removeEventListener("dragover", this.prevDefault);
        window.removeEventListener("drop", this.prevDefault);
        this.$root.$emit("showCheckedSaveBtn", false);
        this.$root.$off("highlightsSave");
    },
    methods: {
        ...mapActions("apps", [
            "saveApp",
            "setDefaultValuesForNewApp",
            "exportApplication",
            "updateApplication",
            "getAppSettingsInfo"
        ]),
        ...mapActions("admin", ["getRoleList", "actionGetGroupsApps"]),
        ...mapActions("version", ["getLatestVersionId"]),
        ...mapActions("userProfile", ["getUserDetails"]),
        ...mapMutations("main", ["setInterfaceDirty"]),
        ...mapMutations("admin", ["setGroupsAppList"]),
        ...mapMutations("documentEditor", ["setAppUpdated"]),
        checkRetentionValues() {
            if (!this.currentApp.retention
            || (this.currentApp.retention.type === "INDEFINITE" && !this.currentApp.retention.period)) {
                this.period = 1;
                this.retentionPeriod = "Y";
            }
        },
        selectRetentionPeriod(value) {
            const extractInitialTime = this.currentApp.retention.period.slice(-1);
            if (!this.currentApp.retention || value !== extractInitialTime) {
                this.retentionPeriod = value;
                this.checkPermissionsInterfaceDirty(true);
            } else {
                this.checkPermissionsInterfaceDirty();
            }
        },
        changePeriod(value) {
            let transformData = null;
            let initialPeriod = null;
            if (this.currentApp.retention.period) {
                [, transformData] = this.currentApp.retention.period.split("P");
                initialPeriod = transformData.slice(0, transformData.length - 1);
            }
            if (!this.currentApp.retention.period || value !== initialPeriod) {
                this.checkPermissionsInterfaceDirty(true);
            } else {
                this.checkPermissionsInterfaceDirty();
            }
        },
        checkIfHasPermissions(data, code) {
            let hasPermissions;
            if (data) {
                if (data.g) {
                    hasPermissions = true;
                } else if (data.AS) {
                    hasPermissions = !!((data.AS.g && data.AS.g === "w") || data.AS[code]);
                }
            }
            return hasPermissions;
        },
        resetErrors() {
            this.appNameValidation = false;
            this.appDescriptionValidation = false;
        },
        checkAppName() {
            if (!this.nameApp) {
                this.appNameValidation = true;
            }
        },
        funtionForNumberOfUsers(rol) {
            let numberOfUsersAndGroups;
            const rolCopy = JSON.parse(JSON.stringify(rol));
            rolCopy.role.noOfGroupMembers.nrOfUsers = parseInt(rol.role.noOfGroupMembers.nrOfUsers, 10);
            rolCopy.role.noOfGroupMembers.nrOfGroups = parseInt(rol.role.noOfGroupMembers.nrOfGroups, 10);
            if (rolCopy.role.noOfGroupMembers.nrOfUsers !== 0) {
                numberOfUsersAndGroups = `${rolCopy.role.noOfGroupMembers.nrOfUsers} `;
                if (rolCopy.role.noOfGroupMembers.nrOfUsers === 1) {
                    numberOfUsersAndGroups += this.$t("admin.usersAndRoles.user");
                } else {
                    numberOfUsersAndGroups += this.$t("admin.usersAndRoles.usersLower");
                }
            }
            if (rolCopy.role.noOfGroupMembers.nrOfGroups !== 0 && rolCopy.role.noOfGroupMembers.nrOfUsers !== 0) {
                numberOfUsersAndGroups += this.$t("admin.usersAndRoles.and");
            }
            if (rolCopy.role.noOfGroupMembers.nrOfGroups !== 0) {
                numberOfUsersAndGroups += `${rolCopy.role.noOfGroupMembers.nrOfGroups} `;
                if (rolCopy.role.noOfGroupMembers.nrOfGroups === 1) {
                    numberOfUsersAndGroups += this.$t("admin.usersAndRoles.role");
                } else {
                    numberOfUsersAndGroups += this.$t("admin.usersAndRoles.rolesLower");
                }
            }
            return numberOfUsersAndGroups;
        },
        downloadApplication() {
            this.exportApplication(currentApp).then(
                () => {}
            ).catch(() => {
                this.$toast.showNotify({
                    type: "error",
                    message: this.$t("apps.downloadError"),
                    timeout: 1000
                });
            });
        },
        statusApp(status) {
            switch (status) {
                case "UNPUBLISHED_CHANGES":
                    this.app.status = "unpublished_changes";
                    break;
                case "PUBLISHED":
                    this.app.status = "published";
                    break;
                default:
                    this.app.status = "unpublished";
                    break;
            }
        },
        initializeComponent() {
            if (
                this.currentApp
        && this.currentApp.id
        && Object.keys(this.currentApp).length > 1
            ) {
                if (!this.currentApp.canView) {
                    this.$root.$emit("editView", true);
                }
                this.$root.$emit("noMenu", false);
                this.statusApp(this.currentApp.publishStatus);
                if (this.currentApp.ownerId) {
                    const owner = this.currentApp.ownerId;
                    this.userList.forEach(el => {
                        if (el.id === owner) {
                            this.app.createdBy = `${el.firstName} ${el.lastName}`;
                        }
                    });
                } else {
                    this.getUserDetails();
                }

                this.nameApp = this.currentApp.name;
                this.appDescription = this.currentApp.description;
                this.previewImage = this.currentApp.imageId ? `${ENGINE_REST_PATH}/app/files/${this.currentApp.imageId}/IMAGE` : null;
                if (this.currentApp.retention && this.currentApp.retention.type === "LIMITED") {
                    this.retentionValue = this.currentApp.retention.type;
                    if (this.currentApp.retention.period) {
                        const retPer = this.currentApp.retention.period;
                        this.retentionPeriod = retPer.slice(-1);
                        const [, transformData] = retPer.split("P");
                        this.period = transformData.slice(0, transformData.length - 1);
                    }
                } else if (this.currentApp.retention && this.currentApp.retention.type === "INDEFINITE") {
                    this.retentionValue = this.currentApp.retention.type;
                }
                if (this.currentApp.blockchainEnabled) {
                    if (this.currentApp.blockchainType === "BLOCKCHAIN") {
                        this.blockchainTypeLabel = this.$t(
                            "apps.blockchainType.blockchain"
                        );
                    }
                } else {
                    this.blockchainTypeLabel = this.$t("apps.blockchainType.standard");
                }
                this.$root.$emit("resetSidebar");
            }
            if (this.currentApp && !this.currentApp.id) {
                this.nameApp = this.$t("apps.defaultNameApp");
                this.blockchainTypeLabel = this.$t("apps.initialBlockchainTypeLabel");
                this.inputActionsCode = "";
                this.appDescription = "";
                this.resetErrors();
            }
            if (
                this.currentApp
        && !this.currentApp.id
        && Object.keys(this.currentApp).length === 0
            ) {
                this.getUserDetails();
                this.$root.$emit("recalculateSidebar", ["applications"]);
                this.setDefaultValuesForNewApp();
            } else if (this.currentApp && this.currentApp.imageId) {
                this.previewImage = `${ENGINE_REST_PATH}/app/files/${this.currentApp.imageId}/IMAGE`;
                // default display value for edit in case it doesnt have a blockchain type
                this.blockchainTypeLabel = this.currentApp.blockchainType;
                if (this.blockchainTypeLabel === null) {
                    this.blockchainTypeLabel = this.$t("apps.blockchainType.standard");
                }
                if (this.blockchainTypeLabel === "BLOCKCHAIN") {
                    this.blockchainTypeLabel = this.$t("apps.blockchainType.blockchain");
                }
            }
            this.getLatestVersionId().then(() => {
                if (this.currentApp && !this.currentApp.appVersion) {
                    this.currentApp.appVersion = this.latestVersionId;
                }
            });
        },

        onFileSelected(f) {
            if (f) {
                this.checkPermissionsInterfaceDirty(true);
            } else {
                this.checkPermissionsInterfaceDirty();
            }
            const image = f;
            if (image.size > this.maxSize.bytesSize) {
                this.$toast.showNotify({
                    message: this.$t("apps.imageSizeError", { maxSize: this.maxSize.value }),
                    type: "negative"
                });
                image.value = null;
            }
            const reader = new FileReader();
            reader.readAsDataURL(image);
            reader.onload = e => {
                this.previewImage = e.result;
            };
            this.avatarToSave = image;
            this.currentApp.image = image;
        },
        removeFile() {
            this.fileUpdateImport = null;
            this.showWarningText = false;
            this.updateDisabledBtn = true;
        },
        inputUpdateChanged(files) {
            this.showWarningText = !!files;
            if (files && files.length) {
                this.fileUpdateImport = files[this.someIndex];
                this.updateDisabledBtn = false;
            } else {
                this.removeFile();
            }
        },
        openUpdateDialog() {
            this.appUpdate = true;
            this.fileUpdateImport = null;
            this.showWarningText = false;
        },
        onUploadUpdate() {
            this.resetErrors();
            const formDataUpdate = new FormData();
            formDataUpdate.append("file", this.fileUpdateImport);
            const fileObj = {
                id: this.currentApp.id,
                file: formDataUpdate
            };
            this.updateApplication(fileObj).then(data => {
                if (data.data.catalogsWarning) {
                    this.$toast.showNotify({
                        message: data.data.catalogsWarning,
                        type: "warning"
                    });
                }
                this.fileUpdateImport = null;
                this.showUploader = false;
                if (data && data.data) {
                    const copyOfImportedAppRsp = data.data;
                    copyOfImportedAppRsp.publishStatus = "UNPUBLISHED_CHANGES";
                    this.$store.commit("apps/setCurrentApp", copyOfImportedAppRsp);
                    this.$store.commit("main/setCurrentApplicationId", data.data.id);
                    this.previewImage = data.data.imageId ? `${ENGINE_REST_PATH}/app/files/${data.data.imageId}/IMAGE` : null;
                }
                this.$toast.showNotify({
                    type: "success",
                    message: this.$t("apps.updated", { appName: data.data.name })
                });
                this.setAppUpdated(true);
                setTimeout(() => {
                    this.showUploader = true;
                }, 0);
            }).catch((err) => {
                this.updateButtonDisabled = true;
                this.$toast.showNotify({
                    type: "error",
                    message: err.response.data.error
                });
            });
        },
        // ramane comentat pt moment
        // setSaveButtonDisplay() {
        //     this.$store.commit("main/setSaveBtnVisible", (this.$route.params && this.$route.params.permissions && this.$route.params.permissions.readonly));
        //     this.$root.$emit("setReadonlyTag", (this.$route.params && this.$route.params.permissions && this.$route.params.permissions.readonly));
        // },
        checkPermissionsInterfaceDirty(interfaceDirty) {
            let setInterfaceDirty = false;
            if (interfaceDirty && this.$route.name === "highlights") {
                setInterfaceDirty = !(this.$route.params && this.$route.params.permissions && this.$route.params.permissions.readonly);
            }
            if (setInterfaceDirty) {
                this.$root.$emit("hideSaveBtn", false);
                this.$root.$emit("showCheckedSaveBtn", false);
            }
            this.$store.commit("main/setInterfaceDirty", setInterfaceDirty);
        },
        loadDataWebsocket() {
            this.getAppSettingsInfo(this.currentApp).then(data => {
                if (data && data.data) {
                    if (data.data.retention.type === "INDEFINITE") {
                        this.period = 1;
                        this.retentionPeriod = "Y";
                        this.retentionValue = "INDEFINITE";
                    } else {
                        const retPer = data.data.retention.period;
                        this.retentionPeriod = retPer.slice(-1);
                        const [, transformData] = retPer.split("P");
                        this.period = transformData.slice(0, transformData.length - 1);
                        this.retentionValue = data.data.retention.type;
                        this.periodRetentionChange++;
                    }
                    this.nameApp = data.data.name;
                    this.currentApp.name = this.nameApp;
                    this.appDescription = data.data.description;
                    this.currentApp.description = this.appDescription;
                    this.currentApp.imageId = data.data.imageId;
                    this.currentApp.imageUrl = data.data.imageUrl;
                    this.currentApp.retention.period = data.data.retention.period;
                    this.currentApp.retention.type = data.data.retention.type;
                    this.previewImage = data.data.imageId ? `${ENGINE_REST_PATH}/app/files/${data.data.imageId}/IMAGE` : null;
                    this.$store.commit("apps/updateCurrentAppInfo", this.currentApp);
                    this.$store.commit("apps/setCurrentApp", this.currentApp);
                }
            });
        },
        removeAvatar() {
            this.previewImage = null;
            this.avatarToSave = null;
            this.imageToRemove = true;
            this.checkPermissionsInterfaceDirty(this.imageToRemove);
        },
        applicationSave() {
            this.selectedDescription = this.appDescription;
            this.appDescriptionValidation = false;
            const retentionValue = {
                period: this.retentionValue === "INDEFINITE" ? null : `P${this.period}${this.retentionPeriod}`,
                type: this.retentionValue
            };
            this.selectedName = this.nameApp;
            if (this.nameApp.length >= 100) {
                this.exceedSize = true;
                this.appNameValidation = true;
            } else if (this.appDescription && this.appDescription.length > 500) {
                this.appDescriptionValidation = true;
            } else if (this.nameApp && !this.checkPeriod) {
                const payload = {
                    id: this.currentApp.id,
                    settings: {
                        name: this.nameApp,
                        description: this.appDescription,
                        retention: retentionValue,
                        image: this.avatarToSave,
                        imageToRemove: this.imageToRemove
                    }
                };
                this.saveApp(payload).then(data => {
                    if (data && data.id) {
                        this.currentApp.name = data.name;
                        this.currentApp.description = data.description;
                        this.currentApp.retention = payload.settings.retention;
                        if (data.imageId) {
                            this.imageToRemove = false;
                            this.currentApp.imageId = data.imageId;
                            this.currentApp.imageUrl = data.imageUrl;
                        }
                        if (payload.settings.imageToRemove) {
                            this.currentApp.imageId = null;
                            this.currentApp.image = {};
                            this.currentApp.imageUrl = null;
                            this.imageToRemove = false;
                        }
                        this.$store.commit("apps/updateCurrentAppInfo", this.currentApp);
                        this.$store.commit("apps/setCurrentApp", this.currentApp);
                        this.$store.commit("main/setCurrentApplicationId", data.id);
                        this.$store.dispatch("admin/actionGetGroupsApps");
                        this.$root.$emit("checkUserOnApp", { name: "highlights", appId: data.id });
                        this.$backendWebsocketEvents.startWebsocket(data.id);
                        this.$store.commit("main/setInterfaceDirty", false);
                        this.$root.$emit("showCheckedSaveBtn", true);
                    }
                });
            }
        }
    }
};
